import axios from '_u/axios'

// 查询用户列表
export const userList = (body) => {
    return axios.post('api/sys/user/list', body)
}

// 查询用户详情
export const userView = (id) => {
    return axios.post('api/sys/user/marketing/view', { id })
}

// 新增用户
export const userAdd = (body) => {
    return axios.post('api/sys/user/marketing/add', body)
}

// 修改用户
export const userUpdate = (body) => {
    return axios.post('api/sys/user/marketing/update', body)
}

// 启用/禁用
export const userEnabled = (id) => {
    return axios.post('api/sys/user/enabled', { id })
}

// 重置密码
export const resetPwd = (id) => {
    return axios.post('api/sys/user/resetPwd', { id })
}

// 查询岗位列表
export const roleList = (body) => {
    return axios.post('api/sys/org/list', body)
}

// 查询岗位详情
export const roleView = (id) => {
    return axios.post('api/sys/org/view', { id })
}

// 新增岗位
export const roleAdd = (body) => {
    return axios.post('api/sys/org/add', body)
}

// 修改岗位
export const roleUpdate = (body) => {
    return axios.post('api/sys/org/update', body)
}

// 删除岗位
export const roleDelete = (id) => {
    return axios.post('api/sys/org/delete', { id })
}

// 销售用户
// 查询用户列表
export const saleUserList = (body) => {
    return axios.post('api/sys/user/saleUserList', body)
}

// 查询用户详情
export const viewSaleUser = (id) => {
    return axios.post('api/sys/user/viewSaleUser', { id })
}

// 修改用户
export const updateSaleUser = (body) => {
    return axios.post('api/sys/user/updateSaleUser', body)
}